import { ISubOrder, IOrder } from 'types/order';

export function isLubanOrder(order: IOrder | ISubOrder) {
    return order && order.biz_type === 1;
}

export function getHumanDate(time: string) {
    const getStringifyDate = (date: Date) =>
        `${date.getFullYear()}${date.getMonth()}${date.getDate()}`;
    const correctTimeStr = time.replace(/\-/g, '/');
    const timeText = correctTimeStr.replace(/^\d{4}-|:\d{1,2}$/g, '').replace('-', '/');
    const clock = timeText.split(' ')[1];
    const nowDate = new Date();
    const logisticsDate = new Date(correctTimeStr);
    const logisticsDateStr = getStringifyDate(logisticsDate);
    const todayDateStr = getStringifyDate(nowDate);
    const yesterdayDateStr = getStringifyDate(new Date(nowDate.setDate(nowDate.getDate() - 1)));

    if (todayDateStr === logisticsDateStr) {
        return `今天 ${clock}`;
    }
    if (yesterdayDateStr === logisticsDateStr) {
        return `昨天 ${clock}`;
    }

    return timeText;
}

// timestamp 为秒
export function countdown(timestamp: number) {
    const endTime = timestamp * 1000;
    const now = new Date().getTime();
    const hour = 3600000;
    const day = hour * 24;
    const diff = endTime - now;
    if (diff <= 0) {
        return '';
    }
    let restDay = Math.floor(diff / day);
    let restHour = Math.ceil((diff % day) / hour);
    if (restDay === 1 && restHour === 0) {
        return '24小时';
    }
    if (restDay >= 1 && restHour === 24) {
        restDay += 1;
        restHour = 0;
    }
    return `${restDay ? restDay + '天' : ''}${restHour ? restHour + '小时' : ''}`;
}
